import { inject, Injectable, OnDestroy, Signal, signal } from '@angular/core';
import { LanguageService } from './language.service';
import { languages, languagesResponse } from '../models/languages.models';
import { Subject, takeUntil } from 'rxjs';
import { RuntimeConfigService } from './runtime-config.service';
import { environment } from '../../environments/environment';

declare global {
  interface Window {
    __env?: { googleMapsApiKey: string };
  }
}

@Injectable({
  providedIn: 'root',
})
export class InitialService implements OnDestroy {
  private _languages = signal<languages[]>([]);
  script = document.createElement('script');
  private runtimeConfigService = inject(RuntimeConfigService);
  private destroy: Subject<boolean> = new Subject<boolean>();

  constructor(private _LanguageService: LanguageService) {}

  async setUpGoogleScript(): Promise<void> {
    const language = localStorage.getItem('language') || 'en';

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const head = document.getElementsByTagName('head')[0];

        if (!document.getElementById('testScriptName')) {
          const apiKey = environment.GOOGLE_API_KEY;
          console.log('apiKey :', apiKey);
          this.script.type = 'text/javascript';

          this.script.src = `https://maps.googleapis.com/maps/api/js?v=quarterly&key=${apiKey}&libraries=marker,visualization,places,geometry,drawing&language=${language}`;
          this.script.id = 'testScriptName';
          this.script.async = true;
          this.script.defer = true;

          this.script.onload = () => {
            const googleMaps = window['google'] as typeof google; // Type assertion
            if (googleMaps && googleMaps.maps) {
              resolve();
            } else {
              reject('Google Maps API failed to load');
            }
          };

          this.script.onerror = error => {
            console.error('Error loading Google Maps script:', error);
            reject('Google Maps API failed to load');
          };

          head.appendChild(this.script);
        }
      }, 100);
    });
  }

  async getLanguages(): Promise<void> {
    this._LanguageService
      .getLanguages('')
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (res: languagesResponse) => {
          this._languages.set(res.list);
        },
      });
  }

  get languages(): Signal<languages[]> {
    return this._languages;
  }

  ngOnDestroy(): void {
    this.destroy.next(true);
    this.destroy.complete();
  }
}
